import React, { useState, useEffect, createContext } from 'react';
import { languages } from '../content_option';

export const LanguageContext = createContext({
    language: 'English', // Valor por defecto
    setLanguage: () => {},
});

const getInitialLanguage = () => {
    // Check if we're in a browser environment
    if (typeof window === "undefined") return 'English';
    
    // Get valid language names from the languages array
    const validLanguages = languages.map(lang => lang.name);
    
    // Get stored language from localStorage
    const storedLang = localStorage.getItem("language");
    
    // Validate that stored language is in the valid languages list
    if (storedLang && validLanguages.includes(storedLang)) {
        return storedLang;
    }
    
    // Fallback to default
    return 'English';
};

export const LanguageProvider = ({ children }) => {
    // 🚀 PASO 2: Guarda el valor inicial en el estado (state) de React
    const [language, setLanguage] = useState(getInitialLanguage());

    // 🚀 PASO 3: Mantén localStorage actualizado cada vez que el estado cambia
    // Este es el useEffect que ya tienes en LanguageToggle, ahora movido al Context
    useEffect(() => {
        localStorage.setItem("language", language);
        document.documentElement.setAttribute("lang", language.slice(0, 2).toLowerCase());
    }, [language]);

    return (
        <LanguageContext.Provider value={{ language, setLanguage }}>
            {children}
        </LanguageContext.Provider>
    );
};